import React, { useState } from 'react';

const Dropdown = ({ toggleText, children, disabled = false, className="", align="left"}) => {
	const [showDropdown, setShowDropdown] = useState(false);
	const baseClass = align === "right" ? "position-absolute end-0 w-100 dropdown-menu" : "w-100 dropdown-menu"
	const dropDownMenuClass = `${baseClass}${showDropdown ? ' show' : ''}`;

	const DropDownItems = ({ children }) => {
		return React.Children.map(children, (child) =>
			<div onClick={() => setShowDropdown(false)}>
				{React.cloneElement(child, {
					className: `${child.props.className || ''} dropdown-item`,
				})}
			</div>
		)
	};

	return (
		<div className="dropdown">
			<button
				className={`btn btn-default btn_dropdown dropdown-toggle w-100 ${className}`}
				onClick={() => setShowDropdown(!showDropdown)}
				type="button"
				disabled={disabled}
			>
				{toggleText}
			</button>
			<div className={`${dropDownMenuClass}`}>
				<DropDownItems children={children} />
			</div>
		</div>
	);
};

export default Dropdown;
